import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    tableContainer: {
        padding: theme.spacing(8, 0),
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
    },
    boldText: {
        fontWeight: "bold",
    },
}));
